var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterXIconWhite = function SvgTwitterXIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
  })));
};
export { SvgTwitterXIconWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNGRkYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEyLjYuNzVoMi40NTRsLTUuMzYgNi4xNDJMMTYgMTUuMjVoLTQuOTM3bC0zLjg2Ny01LjA3LTQuNDI1IDUuMDdILjMxNmw1LjczMy02LjU3TDAgLjc1aDUuMDYzbDMuNDk1IDQuNjMzTDEyLjYwMS43NVptLS44NiAxMy4wMjhoMS4zNkw0LjMyMyAyLjE0NUgyLjg2NXoiLz4KPC9zdmc+";